// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"WordCountInput_wrapper__29O7T","input":"WordCountInput_input__3FqNt","counter":"WordCountInput_counter__3R8Ox"};